// extracted by mini-css-extract-plugin
export var table = "_ut-0";